var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',_vm._g({staticClass:"pa-0 ma-0",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }